/**
 * A hospital's emergency information, as AMTC staff edit and verify it
 * (M35-T04/T05, ADR-0064). amtc_admin only; the server's `hospital_contact:write`
 * capability is the real guard.
 */
import { apiFetch } from './client'

export type EmergencyInfo = {
  slug: string
  name: string
  address: string
  emergency_phone: string | null
  emergency_hours_text: string | null
  has_emergency: boolean | null
  emergency_24h: boolean | null
  lat: number
  lng: number
  emergency_info_verified_at: string | null
  emergency_info_verified_by_user_id: string | null
  emergency_info_verified_by_name: string | null
  location_verified: boolean
}

/** The editable fields only. The server refuses unknown keys, so a GET row
 * can never be sent back as it came. */
export type EmergencyInfoUpdate = {
  address?: string
  emergency_phone?: string | null
  emergency_hours_text?: string | null
  has_emergency?: boolean
  emergency_24h?: boolean
  lat?: number
  lng?: number
  /** true: verify now; false: clear the check without changing a field. */
  mark_info_verified?: boolean
  location_verified?: boolean
}

export const EMERGENCY_INFO_KEY = ['admin', 'emergency-info'] as const

/** Mirrors `backend/app/schemas/hospital_emergency_info.py`, which stays the
 * real guard. Checked here so the error shows on the right field. */
export const GHANA_LAT = [4.5, 11.3] as const
export const GHANA_LNG = [-3.4, 1.3] as const
export const ADDRESS_MAX = 300
export const HOURS_MAX = 120

export async function fetchEmergencyInfo(
  token: string | null,
): Promise<EmergencyInfo[]> {
  const body = await apiFetch<{ data: EmergencyInfo[] }>(
    '/api/v1/admin/hospitals/emergency-info',
    { token },
  )
  return body.data
}

export async function updateEmergencyInfo(
  token: string | null,
  slug: string,
  update: EmergencyInfoUpdate,
): Promise<EmergencyInfo> {
  const body = await apiFetch<{ data: EmergencyInfo }>(
    `/api/v1/admin/hospitals/${encodeURIComponent(slug)}/emergency-info`,
    { token, method: 'PATCH', body: update },
  )
  return body.data
}
